export default __webpack_public_path__ + "static/salwinski_milonga-1cf29ff7b46b9d473665bb6646d2ac60.mp3";